import { useAccount } from 'wagmi';

import { useAppSelector } from 'src/store/utils';

export function useAnalyticsContext() {
  const { address } = useAccount();
  const { networkInfo } = useAppSelector(state => state.app);

  return {
    address: address || undefined,
    network: networkInfo?.id || undefined,
  };
}
